module.exports = InternalShared('InternalShared/PageBuilder/Fields/FieldItemBase');